var _excluded = ["options", "itemClassName"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Label } from "../Label";
import { cn } from "../lib/utils";
import { RadioGroup, RadioGroupItem } from "./radio-group";
export { RadioGroup, RadioGroupItem } from "./radio-group";
export var Radio = function Radio(_ref) {
  var options = _ref.options,
    itemClassName = _ref.itemClassName,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(RadioGroup, props, options.map(function (option) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('flex space-x-2', typeof itemClassName === 'function' ? itemClassName(option) : itemClassName),
      key: option.value
    }, /*#__PURE__*/React.createElement(RadioGroupItem, {
      value: option.value,
      id: option.value
    }), /*#__PURE__*/React.createElement(Label, {
      htmlFor: option.value
    }, option.label));
  }));
};